import { SVGProps } from "react";

const STIYubico = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Yubico" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><circle cx={256} cy={256} fill="none" r={233} stroke="#98c93c" strokeWidth={45} /><path d="M256 407H185l33-77-80-202h69l49 132 46-132h68" fill="#98c93c" /></svg>;

export { STIYubico };